import { Outlet } from "react-router-dom";

import { Header } from "@/components/shared/Header";
import { LiteralEPendingAlert } from "@/components/shared/LiteralEPendingAlert";
import { ProfileBanners } from "@/components/shared/ProfileBanners";
import { Sidebar } from "@/components/shared/Sidebar";
import { UpdateAvailableBanner } from "@/components/shared/UpdateAvailableBanner";
import { PageBackProvider } from "@/contexts/PageBackContext";
import { SidebarProvider, useSidebar } from "@/contexts/SidebarContext";

function LayoutContent(): JSX.Element {
  const { isSidebarOpen } = useSidebar();
  return (
    <div
      className="flex h-screen overflow-hidden bg-[var(--fx-paper)] dark:bg-[var(--fx-ink-800)]"
      data-sidebar={isSidebarOpen ? "open" : "collapsed"}
    >
      <Sidebar />
      <div className="flex flex-1 flex-col overflow-hidden">
        <Header />
        <UpdateAvailableBanner />
        <LiteralEPendingAlert />
        <ProfileBanners />
        {/* The one place the canvas is painted. Everything inside is either
            transparent (layout containers) or a raised surface (cards). */}
        <main className="min-h-0 flex-1 overflow-y-auto bg-[var(--fx-s-canvas)]">
          <Outlet />
        </main>
      </div>
    </div>
  );
}

export function AppLayout(): JSX.Element {
  return (
    <SidebarProvider>
      {/* Wraps the header AND the outlet: pages publish their back action from
          inside the outlet and the header reads it. */}
      <PageBackProvider>
        <LayoutContent />
      </PageBackProvider>
    </SidebarProvider>
  );
}
